module.exports = {
  siteMetadata: {
    title: "Norhart",
    titleTemplate: "%s | Norhart",
    description: "Placeholder",
    url: process.env.NORHART_SITE_URL || "https://www.norhart.com",
    siteUrl: process.env.NORHART_SITE_URL || "https://www.norhart.com",
    image: "",
    twitterUsername: "",
  },
}
